import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';

@Component({
  selector: 'app-zendesk-chat',
  templateUrl: './zendesk-chat.component.html',
  styleUrls: ['./zendesk-chat.component.css']
})
export class ZendeskChatComponent implements OnInit {

  public user: any = this.appSettings.data.user;
  public isActive: boolean = this.user.registration_language === 'ru';

  constructor(
    private appSettings: AppSettingsService
  ) { }

  init() {
    if ( !this.isActive ) { return; }

    (<any>window).zEmbed||function(zendLibPath, t){
      var n,o,i,s,a=[];
      var iframe=document.createElement("iframe");
      (<any>window).zEmbed=function(){
        a.push(arguments);
      };
      (<any>window).zE=(<any>window).zE||(<any>window).zEmbed;
      (<any>iframe).src="javascript:false";
      (<any>iframe).title="";
      (<any>iframe).role="presentation";
      ((<any>iframe).frameElement||(<any>iframe)).style.cssText="display: none";
      var scripts=document.getElementsByTagName("script");
      scripts = (<any>scripts)[(<any>scripts).length-1];
      (<any>scripts).parentNode.insertBefore((<any>iframe),scripts);

      i=(<any>iframe).contentWindow;
      s=i.document;
      try{o=s}catch(zendLibPath){
        n=document.domain,
          (<any>iframe).src='javascript:var d=document.open();d.domain="'+n+'";void(0);',
          o=s
      }
      o.open()._l=function(){
        var o=this.createElement("script");
        n&&(this.domain=n),
          o.id="js-(<any>iframe)-async",
          o.src=zendLibPath,
          this.t=+new Date,
          this.zendeskHost=t,
          this.zEQueue=a,
          this.body.appendChild(o)
      },
        o.write('<body onload="document._l();">'),
        o.close()
    }("https://assets.zendesk.com/embeddable_framework/main.js", "lpgenerator.zendesk.com");
  }


  activate() {
    if ( !this.isActive ) { return; }

    (<any>window).zE.activate()
  }

  ngOnInit() {
    this.init();
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/zendesk-chat/zendesk-chat.component.ts